var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "item_media item_vod" }, [
    _c("div", { staticClass: "wrap_vod_info" }, [
      _c("div", { staticClass: "info_vod", style: _vm.layerStyle }, [
        _c("iframe", {
          attrs: {
            src: _vm.videoPlayUrl,
            title: "YouTube video player",
            frameborder: "0",
            allow:
              "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            allowfullscreen: "",
          },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }